import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  Button,
  Grid,
  ImageList,
  ImageListItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import avatarP1 from "../../images/avatar profile1.svg";
import avatarP2 from "../../images/avatar profile2.svg";
import avatarP3 from "../../images/avatar profile3.svg";
import avatarP4 from "../../images/avatar profile4.svg";
import avatarP5 from "../../images/avatar profile5.svg";
import avatar1 from "../../images/Avatar1.svg";
import avatar2 from "../../images/Avatar2.svg";
import avatar3 from "../../images/Avatar3.svg";
import avatar4 from "../../images/Avatar4.svg";
import avatar5 from "../../images/Avatar5.svg";
import excellarateLogo from "../../images/Excellarate-logo.svg";
import userAvatar from "../../images/User_avatar.svg";
import { useStyles } from "../Common/CommonStyle";
import { LinearLoader } from "../Common/LinearLoader";
import {
  handleAvatar,
  handleEmail,
  handleFirstName,
  handleLastName,
  selectUserDetails,
} from "./userDetailsSlice";
import { useUserDetailsFormValidator } from "./useUserDetailsFormValidator";

const inputStyle = {
  background: "rgba(255, 255, 255, 0.2)",
  backdropFilter: "blur(8px)",
  borderRadius: "12px",
  color: "primary",
  "& .MuiFilledInput-input": { color: "primary" },
  "& .MuiOutlinedInput-root": { borderRadius: "12px" },
  "& .MuiInputLabel-root": { color: "#ABABAB" },
};
export interface UserDetailsProps {
  hideIntro: any;
  showProgress: boolean;
}

export const imageData: any = [
  {
    id: "0",
    img: userAvatar,
    title: "Avatar0",
    selected: true,
    chatImage: userAvatar,
  },
  {
    id: "1",
    img: avatar1,
    title: "Avatar1",
    selected: false,
    chatImage: avatarP1,
  },
  {
    id: "2",
    img: avatar2,
    title: "Avatar2",
    selected: false,
    chatImage: avatarP2,
  },
  {
    id: "3",
    img: avatar3,
    title: "Avatar3",
    selected: false,
    chatImage: avatarP3,
  },
  {
    id: "4",
    img: avatar4,
    title: "Avatar4",
    selected: false,
    chatImage: avatarP4,
  },
  {
    id: "5",
    img: avatar5,
    title: "Avatar5",
    selected: false,
    chatImage: avatarP5,
  },
];
export const UserDetails = ({ hideIntro, showProgress }: UserDetailsProps) => {
  const [selected, setSelected] = useState(imageData);
  const [form, setForm] = useState({
    fname: "",
    lname: "",
    email: "",
  });

  const { errors, validateForm, onBlurField } =
    useUserDetailsFormValidator(form);
  const { fname, lname, email, avatar } = useSelector(selectUserDetails);
  const dispatch = useDispatch();
  const classes = useStyles();

  React.useEffect(() => {
    dispatch(handleAvatar(0));
  }, []);

  const onUpdateField = (e: any) => {
    const field = e.target.name;
    const nextFormState = {
      ...form,
      [field]: e.target.value,
    };
    setForm(nextFormState);
    if (field === "fname") {
      dispatch(handleFirstName(e.target.value));
    }
    if (field === "lname") {
      dispatch(handleLastName(e.target.value));
    }
    if (field === "email") {
      dispatch(handleEmail(e.target.value));
    }
    if (errors[field].dirty)
      validateForm({
        form: nextFormState,
        errors,
        field,
      });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const { isValid } = validateForm({ form, errors, forceTouchErrors: true });
    if (!isValid) return;

    if (fname !== "" && lname !== "" && email !== "") {
      fetch("https://go.excellarate.com/l/130341/2022-09-20/3rb4tk", {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "*/*",
        },
        mode: "no-cors",
        referrer: "",
        body: new URLSearchParams({
          fname: fname,
          lname: lname,
          email: email,
        }),
      })
        .then((response) => {
          hideIntro();
        })
        .catch((err) => {
          console.log("error -> ", err);
        });
    }
  };

  const handleAvatarClick = (e: any, item: any) => {
    setSelected({ ...item, selected: true });
    dispatch(handleAvatar(e.target.id));
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid
          container
          className={classes.positionComponent}
          sx={{ background: "rgba(12, 13, 33, 0.8)", height: "100vh" }}
        >
          <Grid item>
            <img
              src={excellarateLogo}
              alt="excellarate logo"
              style={{ padding: "1.25rem 0 0 1.875rem" }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h4"
              color="primary"
              sx={{ m: "0.25rem 0 1rem", textAlign: "center" }}
            >
              What's your name?
            </Typography>
            <Grid container spacing={2} sx={{ width: 530 }}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="fname"
                  label="First name*"
                  sx={{ ...inputStyle }}
                  variant="outlined"
                  name="fname"
                  defaultValue={fname}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                  className={
                    errors.fname.dirty && errors.fname.error ? "error" : ""
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="lname"
                  label="Last name*"
                  sx={{ ...inputStyle }}
                  variant="outlined"
                  name="lname"
                  defaultValue={lname}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                  className={
                    errors.lname.dirty && errors.lname.error ? "error" : ""
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="email"
                  label="Enter your email*"
                  sx={{ ...inputStyle }}
                  variant="outlined"
                  name="email"
                  defaultValue={email}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                  className={
                    errors.email.dirty && errors.email.error ? "error" : ""
                  }
                />
                {errors.fname.dirty && errors.fname.error ? (
                  <Typography sx={{ color: "#D65C5C", fontSize: "16px" }}>
                    {errors.fname.message}
                  </Typography>
                ) : errors.lname.dirty && errors.lname.error ? (
                  <Typography sx={{ color: "#D65C5C", fontSize: "16px" }}>
                    {errors.lname.message}
                  </Typography>
                ) : errors.email.dirty && errors.email.error ? (
                  <Typography sx={{ color: "#D65C5C", fontSize: "16px" }}>
                    {errors.email.message}
                  </Typography>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" color="primary" sx={{ m: "1rem 0 0" }}>
              Select your avatar
            </Typography>
            <ImageList
              sx={{
                gap: "0.625rem !important",
                margin: "0.5rem 0",
                width: "55rem",
              }}
              cols={5}
            >
              {imageData.map(
                (item: any) =>
                  item.id !== "0" && (
                    <ImageListItem
                      key={item.img}
                      sx={{
                        height: 200,
                        width: "10rem",
                        padding: "0.188rem",
                        borderRadius: "1rem",
                      }}
                    >
                      <img
                        className={
                          selected.id === item.id && selected.selected
                            ? "selected"
                            : ""
                        }
                        id={item.id}
                        src={`${item.img}`}
                        srcSet={`${item.img}`}
                        alt={item.title}
                        loading="lazy"
                        style={{
                          borderRadius: "1rem",
                          background: "primary",
                          backdropFilter: "blur(22.5833px)",
                          cursor: "pointer",
                        }}
                        defaultValue={avatar}
                        onClick={(e) => handleAvatarClick(e, item)}
                      />
                    </ImageListItem>
                  ),
              )}
            </ImageList>
          </Grid>
          {showProgress ? (<LinearLoader />) : (
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: "center", m: '0.5rem 0', }}>
              <Button type="submit" sx={{ height: '66px', borderRadius: '3rem', textTransform: 'capitalize', padding: '0.75rem 1.25rem' }}
                variant="contained" endIcon={<ArrowForwardIcon />}>Continue</Button>
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography color="primary" sx={{ m: "0 0 0.438rem 1.875rem" }}>
              © 2022 Excellarate. All Rights Reserved
            </Typography>
          </Grid>
        </Grid>
      </form>
    </>
  );
};
